import React from 'react';
import './App.css';
import './CatalogApp.css';
import './CatalogImageList.css';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { useRtoaster } from './hooks/useRtoaster';

// ゴルフページ
import golfPlanList from './pages/golfPlanList';
import golfSearch from './pages/golfSearch';
import golfLogin from './pages/golfLogin';
import startTimeSelect from './pages/startTimeSelect';
import golfInput from './pages/golfInput';
import golfConfirm from './pages/golfConfirm';
import golfComplete from './pages/golfComplete';
import golfBookingConfirmDetail from './pages/golfBookingConfirmDetail';
import GolfCancel from './pages/golfCancel';
import ChangeStartTimeSelect from './pages/changeStartTimeSelect';
import GolfReservationCheck from './pages/golfReservationCheck';
import GolfReservationCheckDetail from './pages/golfReservationCheckDetail';

// ゴルフ(1人予約)ページ
import golfSoloSearch from './pages/golfSoloSearch';
import soloStartTimeSelect from './pages/soloStartTimeSelect';
import golfSoloInput from './pages/golfSoloInput';
import golfSoloConfirm from './pages/golfSoloConfirm';
import golfSoloComplete from './pages/golfSoloComplete';
import golfSoloBookingConfirmDetail from './pages/golfSoloBookingConfirmDetail';
import golfSoloCancel from './pages/golfSoloCancel';

// RTCC海外予約ページ
import top from './pages/RTCC/top';
import rtccReservation from './pages/RTCC/rtccReservation';
import rtccReservationResult from './pages/RTCC/rtccReservationResult';
import rtccReservationComplete from './pages/RTCC/rtccReservationComplete';
import rtccUserInput from './pages/RTCC/rtccUserInput';
import rtccUserInputConfirm from './pages/RTCC/rtccUserInputConfirm';
import rtccInputCancelComplete from './pages/RTCC/rtccInputCancelComplete';
import rtccInputFlight from './pages/RTCC/rtccInputFlight';
import rtccInputFlightConfirm from './pages/RTCC/rtccInputFlightConfirm';
import rtccInputFlightComplete from './pages/RTCC/rtccInputFlightComplete';
import rtccInputPassport from './pages/RTCC/rtccInputPassport';
import rtccInputPassportConfirm from './pages/RTCC/rtccInputPassportConfirm';
import rtccInputPassportComplete from './pages/RTCC/rtccInputPassportComplete';
import rtccBookingConfirmDetail from './pages/RTCC/rtccBookingConfirmDetail';
import RtccBookingCancel from './pages/RTCC/rtccBookingCancelDetail';

// CATALOGページ
import catalogHome from './pages_catalog/catalogHome';
import catalogQuestion from './pages_catalog/catalogQuestion';
import catalog404 from './pages_catalog/catalog404';
import catalogHowtoJp from './pages_catalog/catalogHowtoJp';
import catalogHowtoOverseas from './pages_catalog/catalogHowtoOverseas';
import catalogAboutService from './pages_catalog/catalogAboutService';
import catalogNewsAll from './pages_catalog/catalogNewsAll';
import catalogNewsDetail from './pages_catalog/catalogNewsDetail';
import catalogLineupJp from './pages_catalog/catalogLineupJp';
import catalogLineupOverseas from './pages_catalog/catalogLineupOverseas';

//会員制ページ

//ホテル
import membershipSearch from './pages_membership_hotel/hotel/membershipSearch';
import membershipSearchResult from './pages_membership_hotel/hotel/membershipSearchResult';
import cancelComplete from './pages_membership_hotel/hotel/cancelComplete';
import reserveComplete from './pages_membership_hotel/hotel/reserveComplete';
import cancelWaitComplete from './pages_membership_hotel/hotel/cancelWaitComplete';
import membershipInputUser from './pages_membership_hotel/hotel/membershipInputUser';
import membershipconfirmUser from './pages_membership_hotel/hotel/membershipConfirmUser';
import membershipChooseRight from './pages_membership_hotel/hotel/membershipChooseRight';
import MembershipInputAccompany from './pages_membership_hotel/hotel/membershipInputAccompany';
import MembershipConfirmAccompany from './pages_membership_hotel/hotel/membershipConfirmAccompany';
import MembershipCompleteAccompany from './pages_membership_hotel/hotel/membershipCompleteAccompany';
import MembershipBookingConfirmDetail from './pages_membership_hotel/hotel/membershipBookingConfirmDetail';
import MembershipCrawl from './pages_membership_hotel/hotel/membershipCrawl';
import MembershipCrawlSearch from './pages_membership_hotel/hotel/membershipCrawlSearch';
import MembershipChangePlan from './pages_membership_hotel/hotel/membershipChangePlan';
import MembershipVacancy from './pages_membership_hotel/hotel/membershipVacancy';

//外来予約（エステ・レストラン）
import importedCancelComplete from './pages_membership_hotel/esthetic/importedCancelComplete';
import estheticReserve from './pages_membership_hotel/esthetic/estheticReserve';
import restaurantReserve from './pages_membership_hotel/esthetic/restaurantReserve';
import restaurantReserveAll from './pages_membership_hotel/esthetic/restaurantReserveAll';
import estheticConfirmUser from './pages_membership_hotel/esthetic/estheticConfirmUser';
import restaurantConfirmUser from './pages_membership_hotel/esthetic/restaurantConfirmUser';
import estheticReserveComplete from './pages_membership_hotel/esthetic/estheticReserveComplete';
import restaurantReserveComplete from './pages_membership_hotel/esthetic/restaurantReserveComplete';
import ImportedBookingConfirmDetail from './pages_membership_hotel/esthetic/importedBookingConfirmDetail';

const App = () => {
  // useRtoaster();

  return (
      // 遷移情報記載
      <BrowserRouter>
        <Switch>
          {/* ゴルフ */}
          <Route exact path="/reserve/login" component={golfLogin} />
          <Route exact path="/reserve/golf/search" component={golfSearch} />
          <Route exact path="/reserve/golf/searchResult" component={golfPlanList} />
          <Route exact path="/reserve/golf/startTime" component={startTimeSelect} />
          <Route exact path="/reserve/golf/userInput" component={golfInput} />
          <Route exact path="/reserve/golf/confirm" component={golfConfirm} />
          <Route exact path="/reserve/golf/complete" component={golfComplete} />
          <Route exact path="/reserve/golf/bookingConfirmDetaile" component={golfBookingConfirmDetail} />
          <Route exact path="/reserve/golf/cancel" component={GolfCancel} />
          <Route exact path="/reserve/golf/changeStartTime" component={ChangeStartTimeSelect} />
          <Route exact path="/reserve/golf/reservationCheck" component={GolfReservationCheck} />
          <Route exact path="/reserve/golf/reservationCheckDetail" component={GolfReservationCheckDetail} />

          {/* ゴルフ(1人予約) */}
          <Route exact path="/reserve/golf/soloSearch" component={golfSoloSearch} />
          <Route exact path="/reserve/golf/soloStartTime" component={soloStartTimeSelect} />
          <Route exact path="/reserve/golf/soloUserInput" component={golfSoloInput} />
          <Route exact path="/reserve/golf/soloConfirm" component={golfSoloConfirm} />
          <Route exact path="/reserve/golf/soloComplete" component={golfSoloComplete} />
          <Route exact path="/reserve/golf/soloBookingConfirmDetail" component={golfSoloBookingConfirmDetail} />
          <Route exact path="/reserve/golf/soloCancel" component={golfSoloCancel} />

          {/* RTCC */}
          <Route exact path="/reserve/top" component={top} />
          <Route exact path="/reserve/rtcc/reservation" component={rtccReservation} />
          <Route exact path="/reserve/rtcc/reservationResult" component={rtccReservationResult} />
          <Route exact path="/reserve/rtcc/userInput" component={rtccUserInput} />
          <Route exact path="/reserve/rtcc/userInputConfirm" component={rtccUserInputConfirm} />
          <Route exact path="/reserve/rtcc/reservationComplete" component={rtccReservationComplete} />
          <Route exact path="/reserve/rtcc/inputCancelComplete" component={rtccInputCancelComplete} />
          <Route exact path="/reserve/rtcc/inputFlight" component={rtccInputFlight} />
          <Route exact path="/reserve/rtcc/inputFlightConfirm" component={rtccInputFlightConfirm} />
          <Route exact path="/reserve/rtcc/inputFlightComplete" component={rtccInputFlightComplete} />
          <Route exact path="/reserve/rtcc/inputPassport" component={rtccInputPassport} />
          <Route exact path="/reserve/rtcc/inputPassportConfirm" component={rtccInputPassportConfirm} />
          <Route exact path="/reserve/rtcc/inputPassportComplete" component={rtccInputPassportComplete} />
          <Route exact path="/reserve/rtcc/bookingConfirmDetail" component={rtccBookingConfirmDetail} />
          <Route exact path="/reserve/rtcc/bookingCancelDetail" component={RtccBookingCancel} />
          <Route exact path="/rtcc/catalog/home" component={catalogHome} />

          {/* CATALOG */}
          <Route exact path="/rtcc/catalog/question" component={catalogQuestion} />
          <Route exact path="/rtcc/catalog/404" component={catalog404} />
          <Route exact path="/rtcc/catalog/howToReserveJp" component={catalogHowtoJp} />
          <Route exact path="/rtcc/catalog/howToReserveOverseas" component={catalogHowtoOverseas} />
          <Route exact path="/rtcc/catalog/aboutService" component={catalogAboutService} />
          <Route exact path="/rtcc/catalog/newsAll" component={catalogNewsAll} />
          <Route exact path="/rtcc/catalog/newsDetail" component={catalogNewsDetail} />
          <Route exact path="/rtcc/catalog/hotelLineupJp" component={catalogLineupJp} />
          <Route exact path="/rtcc/catalog/hotelLineupOverseas" component={catalogLineupOverseas} />

          {/* 会員制(ホテル) */}
          <Route exact path="/reserve/hotel/search" component={membershipSearch} />
          <Route exact path="/reserve/hotel/searchResult" component={membershipSearchResult} />
          <Route exact path="/reserve/hotel/cancelComplete" component={cancelComplete} />
          <Route exact path="/reserve/hotel/reserveComplete" component={reserveComplete} />
          <Route exact path="/reserve/hotel/cancelWaitComplete" component={cancelWaitComplete} />
          <Route exact path="/reserve/hotel/inputUser" component={membershipInputUser} />
          <Route exact path="/reserve/hotel/confirmUser" component={membershipconfirmUser} />
          <Route exact path="/reserve/hotel/chooseRight" component={membershipChooseRight} />
          <Route exact path="/reserve/hotel/inputAccompany" component={MembershipInputAccompany} />
          <Route exact path="/reserve/hotel/confirmAccompany" component={MembershipConfirmAccompany} />
          <Route exact path="/reserve/hotel/completeAccompany" component={MembershipCompleteAccompany} />
          <Route exact path="/reserve/hotel/hotelBookingConfirmDetail" component={MembershipBookingConfirmDetail} />
          <Route exact path="/reserve/hotel/crawlLogin" component={MembershipCrawl} />
          <Route exact path="/reserve/hotel/crawlSearch" component={MembershipCrawlSearch} />
          <Route exact path="/reserve/hotel/changePlan" component={MembershipChangePlan} />
          <Route exact path="/hotel/vacancy_public" component={MembershipVacancy} />

          {/* 会員制(エステ) */}
          <Route exact path="/reserve/hotel/importedCancelComplete" component={importedCancelComplete} />
          <Route exact path="/reserve/hotel/facilityReserve/:shisetsuCd/:estheticCd" component={estheticReserve} />
          <Route exact path="/reserve/hotel/facilityReserve/" component={estheticReserve} />
          <Route exact path="/reserve/hotel/restaurantReserveAll" component={restaurantReserveAll} />
          <Route exact path="/reserve/hotel/restaurantReserve" component={restaurantReserve} />
          <Route exact path="/reserve/hotel/facilityConfirmUser" component={estheticConfirmUser} />
          <Route exact path="/reserve/hotel/restaurantConfirmUser" component={restaurantConfirmUser} />
          <Route exact path="/reserve/hotel/facilityReserveComplete" component={estheticReserveComplete} />
          <Route exact path="/reserve/hotel/restaurantReserveComplete" component={restaurantReserveComplete} />
          <Route exact path="/reserve/hotel/importedBookingConfirmDetail" component={ImportedBookingConfirmDetail} />
          <Route exact path="/reserve/hotel/estheticReserve/:shisetsuCd/:estheticCd" render={(props) => <Redirect to={`/reserve/hotel/facilityReserve/${props.match.params.shisetsuCd}/${props.match.params.estheticCd}`} />} />
          <Route exact path="/reserve/hotel/estheticReserve/" render={() => <Redirect to="/reserve/hotel/facilityReserve/" />} />
          <Route exact path="/reserve/hotel/estheticConfirmUser" render={() => <Redirect to="/reserve/hotel/facilityConfirmUser" />} />
          <Route exact path="/reserve/hotel/estheticReserveComplete" render={() => <Redirect to="/reserve/hotel/facilityReserveComplete" />} />

          {/* 追記：上記以外のパスが指定された場合は、ログインへリダイレクト */}
          <Route path="*" render={() => <Redirect to="/reserve/login" />} />
          <Route path="/hotel/*" render={() => <Redirect to="/hotel/vacancy_public" />} />
          <Route path="/rtcc/catalog/*" render={() => <Redirect to="/rtcc/catalog/home" />} />
        </Switch>
      </BrowserRouter>
    )
}

export default App;